import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";
import SideNavLayout from "../customsidenav/sidenavlayout";
import { Backdrop, CircularProgress, styled } from "@mui/material";
import { deletegrey, eyegrey, filtergrey, sendicongrey } from "../utils/svgs/svgcode";
import StatusModal from "./statusmodal";
import api from "../api/api";
import OnBoardView from "./OnBoardView";
import ToastMessage from "../utils/mui/righttoptoast";
import ArchiveIcon from '@mui/icons-material/Archive';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import DeleteConformation from "./deletemodal";
import Checkpatientmodal from "./checkpatiendmodal";
import { useSelector } from "react-redux";
import UnmatchedMapping from "./unmatchedmapping";
import WebRequestsTable from "../fax/webrequesttable";
import { getPracticeId, offeredDepartmentId, practiceFeatures, practiceShortName } from "../config/practice";

const CustomDateCalendar = styled("div")(() => ({})); // Placeholder for future calendar use

// Tab index -> the practice feature it needs. Unmatched mapping = legacy
// Dallas patients, Web Requests = high-bp.com leads: 9928 only.
const ONBOARDING_TAB_FEATURE = { 1: "dallasMigration", 2: "websiteLeads" };

// `embedded` (the unified Inbox's Requests queue, src/inbox/InboxPage.jsx):
// one tab of this page -- `initialTab` -- inside the Inbox's own layout (no
// side-nav wrapper, no tab row). Without it (/onboarding): exactly as before.
const Onboarding = ({ embedded = false, initialTab = 0 }) => {
  const practiseid = getPracticeId();
  const [statusFilter, setStatusFilter] = useState(1);
  const [mainTab, setMainTab] = useState(initialTab); // 0 Onboarding | 1 Unmatched patient mapping | 2 Web Requests
  const [statusmodal, setStatusModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [patients, setPatients] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredPatients, setFilteredPatients] = useState([]);
const [selectedview,setSelectedView]=useState({})
const [ismodal,setIsModal]=useState(false)
const [isCheckpatientmodal,SetCheckPatientModal]=useState('')
const[athenaResult,setAthenaResult]=useState(false)
const[deletemodal,setDeletemodal]=useState(false)
  const [alertmessage, setAlertMessage] = useState('');
  const [severity, setSeverity] = useState('success');
  const [open, setOpen] = useState(false);
  const [rowId, setRowId] = useState(false);
  const  [status,setStatus]=useState(false)
    const userConfig = useSelector((state) => state.userconfig);
  const handlealert = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };
  console.log(userConfig,'usee')

  const getdetails = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/v1/${practiseid}/onboarding/get_all_patients?status=${statusFilter}`);
      const res = response.data || [];

      const formattedData = res.map((item) => ({
        id: item.id,
        patientid: item.patientid,
        name: `${item.firstname} ${item.lastname}`,
        phone: item.phone,
        dob: dayjs(item.dob).format("MMM D, YYYY"),
        email: item.email,
        created: dayjs(item.created_at).format("MMM D, YYYY h:mm a"),
        // status: item.status === 1 ? "Active" : "Archive",
        status: item.status === 1 ? "Active" : item.status === 2 ? "Archive" : item.status === 3 ? "Needs Call Back" : "Active",
        totaldata:item
      }));

      setPatients(formattedData);
      setFilteredPatients(formattedData);
    } catch (error) {
      console.error("Error fetching patient data", error);
    } finally {
      setLoading(false);
    }
  };
const handleDelete=async()=>{
  try {
    setLoading(true)
    const response=await api.delete(`/v1/${practiseid}/onboarding/${selectedview?.id}/delete`)
if(response.status==200){
setAlertMessage('Deleted Successfully')
setSeverity('success')
setOpen(true)
setDeletemodal(false)
}else{
setAlertMessage(response?.message)
setSeverity('info')
setOpen(true)
}

  } catch (error) {
setAlertMessage('Something Went Wrong')
setSeverity('error')
setOpen(true)
    console.log(error)
  }finally{
getdetails()
setLoading(false)

  }
}

  const handleStatusClick = (id) => {
    setRowId(id);  // Set the row-id when the status is clicked
    setStatusModal(true);  // Open the modal
  };


  useEffect(() => {
    document.title = `${practiceShortName()} - Onboarding Patients`;
    getdetails();
  }, [statusFilter]);
const checkpatient = async (data) => {
  try {
    setLoading(true);
    console.log(data,'from ap')
 const form1Data = data?.form_1 ? JSON.parse(data.form_1) : {};

// const payload = {
//   departmentid: userConfig?.config?.departmentid|| "",
//   phone: form1Data?.phone || "",
//   firstname: form1Data?.firstname || "",
//   lastname: form1Data?.lastname || "",
//   dob: form1Data?.dob || "",
//   // mobilecarrierid: form1Data?.mobilecarrierid || "",
//   sex: form1Data?.sex || "",
//   homephone: form1Data?.homephone || "",
//   email: form1Data?.email || "",
//   address1: form1Data?.address || "",
//   zip: form1Data?.zipcode || "",
//   // ssn: form1Data?.ssn || "",
// };

// const response = await api.post(`/v1/${practiseid}/onboarding/patient/check-or-create`,payload);
const response = await api.get(`/v1/${practiseid}/onboarding/patient/check`, {
  params: {
    firstname: form1Data?.firstname || "",
    lastname: form1Data?.lastname || "",
    dob: form1Data?.dob || "",
  }
});
console.log(response.data,'res')
if (response.status==200||response.status==201) {
  setAthenaResult(response?.data)
  setStatus(response?.found||false)
  SetCheckPatientModal(true);
}else{
  setAlertMessage(response?.message)
setSeverity('info')
setOpen(true)
}

    // Handle the response if needed
    console.log(response.data);
  } catch (error) {
    setAlertMessage('Something Went Wrong')
setSeverity('error')
setOpen(true)
    console.error("Error checking patient:", error);
  } finally {
    setLoading(false);
  }
};
const saveAthenaId=async(pid)=>{
  try {
    setLoading(true)
    const response=await api.put(`/v1/${practiseid}/onboarding/${selectedview?.id}/set-patientid`,{patientid:Number(pid)})
    if(response.status==200){
      setAlertMessage(`Athena id ${pid} saved`)
      setSeverity('success')
      setOpen(true)
      SetCheckPatientModal(false)
      getdetails()
    }else{
      setAlertMessage(response?.message||'Failed to save id')
      setSeverity('error')
      setOpen(true)
    }
  } catch (error) {
    setAlertMessage(error?.response?.data?.message||'Something Went Wrong')
    setSeverity('error')
    setOpen(true)
  }finally{
    setLoading(false)
  }
}
const submitToEmr=async()=>{
try {
   const form1Data = selectedview?.form_1 ? JSON.parse(selectedview.form_1) : {};
setLoading(true);
const payload = {
  // The intake's own location (the department its route stamped: /onboard-code
  // 3, /onboard-frisco 2, else 1) becomes the patient's Athena primary
  // department, not the staff member's (PLAN-DEPT3 D6c, recommended answer).
  // The staff member's department only for a row without a listed one.
  departmentid: offeredDepartmentId(selectedview?.departmentid) || userConfig?.config?.departmentid || "",
  phone: form1Data?.phone || "",
  firstname: form1Data?.firstname || "",
  lastname: form1Data?.lastname || "",
  dob: form1Data?.dob || "",
  // mobilecarrierid: form1Data?.mobilecarrierid || "",
  sex: form1Data?.sex || "",
  homephone: form1Data?.homephone || "",
  email: form1Data?.email || "",
  address1: form1Data?.address || "",
  zip: form1Data?.zipcode || "",
  // ssn: form1Data?.ssn || "",
};
const response =await api.post(`/v1/${practiseid}/onboarding/patient/create`,payload)
  if(response.status==200){
  setAlertMessage(response?.message)
setSeverity('success')
setOpen(true)
SetCheckPatientModal(false)
  }else{
  setAlertMessage(response?.message)
setSeverity('info')
setOpen(true)

  }
} catch (error) {
  console.log(error)
  setAlertMessage('Something Went Wrong')
setSeverity('error')
setOpen(true)
}finally{
setLoading(false)
}
}
  // Handle search functionality
  useEffect(() => {
    const filtered = patients.filter(patient =>
      patient.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      patient.phone.includes(searchTerm) ||
      patient.email.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredPatients(filtered);
  }, [searchTerm, patients]);

  // The Inbox renders the page inside its own layout.
  const Shell = embedded ? React.Fragment : SideNavLayout;

  return (
    <div className="h-full">
      <Shell>
        {/* Page tabs */}
        {!embedded && (
        <div className="flex gap-6 border-b border-[#E4E4E7] mb-4">
          {["Onboarding", "Unmatched patient mapping", "Web Requests"].map((label, i) => (
            ONBOARDING_TAB_FEATURE[i] && !practiceFeatures()[ONBOARDING_TAB_FEATURE[i]] ? null :
            <button
              key={label}
              className={`pb-2 text-sm font-semibold ${
                mainTab === i
                  ? "text-[#50869A] border-b-2 border-[#50869A]"
                  : "text-gray-500"
              }`}
              onClick={() => setMainTab(i)}
            >
              {label}
            </button>
          ))}
        </div>
        )}
        {mainTab === 1 && <UnmatchedMapping />}
        {/* New-patient leads from the public website (high-bp.com booking
            widget) — people who requested a visit but haven't completed the
            intake form yet. Completed intakes appear in the main list. */}
        {mainTab === 2 && <WebRequestsTable type="new_patient" />}
        {mainTab === 0 && (
        <>
        {/* Search bar */}
        <div className="w-full flex justify-end mb-4">
          <div className="relative w-full max-w-md">
            <div className="flex items-center w-[80%] bg-[#F5F6FA] border border-[#D5D5D5] rounded-[15px]">
              <FontAwesomeIcon icon={faSearch} className="text-gray-400 ml-3" />
              <input
                type="text"
                className="bg-[#F5F6FA] flex-grow py-1 pl-2 pr-3 text-base outline-none rounded-[15px]"
                placeholder="Search by name, phone, or email"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Dropdown filter */}
        <div className="w-full flex justify-between items-center mt-2">
          <div className="w-fit flex items-center gap-4">
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="px-3 py-2 rounded-[6px] border border-[#E4E4E7] bg-white text-sm text-gray-700 outline-none"
            >
              <option value="1">Active</option>
              <option value="2">Archive</option>
              <option value="3">Needs Call Back</option>
            </select>
            {/* {filtergrey} */}
          </div>
        </div>

        {/* Patient Table */}
        <div className="overflow-auto mt-8 rounded-t-2xl shadow-md max-h-[500px]">
          <table className="min-w-full table-auto border-collapse">
            <thead>
              <tr
                className="text-left text-sm sticky top-0"
                style={{
                  borderBottom: "1px solid #E4E4E7",
                  background: "#50869A",
                }}
              >
                <th className="py-3 px-4 font-medium text-white">Patient Name</th>
                <th className="py-3 px-4 font-medium text-white">Phone</th>
                <th className="py-3 px-4 font-medium text-white">Date of Birth</th>
                <th className="py-3 px-4 font-medium text-white">Email</th>
                <th className="py-3 px-4 font-medium text-white">Created On</th>
                <th className="py-3 px-4 font-medium text-white">Status</th>
                <th className="py-3 px-4 font-medium text-white">Action</th>
              </tr>
            </thead>

            <tbody className="text-sm text-[#1D2951]">
              {filteredPatients.length > 0 ? (
                filteredPatients.map((item, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 text-start hover:bg-gray-50"
                  >
                    <td className="py-3 px-4 font-medium text-[#000]">{item.name} {item.patientid ? `(${item.patientid})` : ''}</td>
                    <td className="py-3 px-4 font-medium text-[#000]">{item.phone}</td>
                    <td className="py-3 px-4 font-medium text-[#000]">{item.dob}</td>
                    <td className="py-3 px-4 text-[#71717A]">{item.email}</td>
                    <td className="py-3 px-4 text-[#71717A]">{item.created}</td>
                    <td className="py-3 px-4">
                      <span
                        onClick={() => handleStatusClick(item.id)}
                        className={`rounded-full cursor-pointer px-3 py-1 text-sm font-medium whitespace-nowrap ${
                          item.status === "Active"
                            ? "bg-[#FFEDD5] text-[#C2410C]"
                            : "bg-[#E0E7FF] text-[#1E3A8A]"
                        }`}
                      >
                        {item.status}
                      </span>
                    </td>
                    <td className="py-3 px-4">
                      <div className="flex gap-2 items-center">
                        <div
                        onClick={()=>{

                          setSelectedView(item?.totaldata)
                          setIsModal(true)
                        }}
                        
                        className="cursor-pointer">
                          {eyegrey}
                        </div>
                           <div
                        onClick={()=>{
                          setSelectedView(item?.totaldata)
                          setDeletemodal(true)
                        }}
                        
                        className="cursor-pointer">
                          {deletegrey}
                          {/* {statusFilter === '1' ? (
                            <ArchiveIcon style={{ color: '#767676' }} />
                          ) : (
                            <UnarchiveIcon style={{ color: '#767676' }} />
                          )} */}
                        </div>
                             <div
                        onClick={()=>{
                          console.log(item?.totaldata)
                          setSelectedView(item?.totaldata)
                       checkpatient(item?.totaldata)
                        }}
                        
                        className="cursor-pointer">
                        {sendicongrey}
                        </div>
                         
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7} className="py-8 text-center text-gray-500">
                   {!loading&&'No Data Found'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        </>
        )}

        {/* Status Modal */}
        <StatusModal ismodal={statusmodal} setisModal={setStatusModal} rowId={rowId} getdetails={getdetails}/>
        <Checkpatientmodal submit={submitToEmr} status={status} ismodal={isCheckpatientmodal} setIsmodal={SetCheckPatientModal} data={selectedview} athenaResult={athenaResult} onSaveId={saveAthenaId}/>
 <ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handlealert} />
        {/* Loader */}
        <Backdrop
          sx={{
            color: "secondary.main",
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={loading}
        >
          <CircularProgress color="secondary" />
        </Backdrop>
        <OnBoardView ismodal={ismodal} setIsModal={setIsModal} data={selectedview} />
        <DeleteConformation ismodal={deletemodal} setIsmodal={setDeletemodal} fun={handleDelete} data={selectedview}/>
      </Shell>
    </div>
  );
};

export default Onboarding;